import { Reveal } from "./Reveal";

export default function ProcessFlow({ steps, idPrefix = "flow" }) {
  return (
    <div className="relative grid gap-10 lg:gap-8 lg:grid-cols-4" data-testid={`${idPrefix}-flow`}>
      <div
        className="hidden lg:block absolute top-6 left-[12%] right-[12%] h-px bg-gradient-to-r from-gold-400/0 via-gold-400/40 to-gold-400/0"
        aria-hidden="true"
      />
      {steps.map((step, i) => (
        <Reveal key={i} delay={i * 0.12} className="relative flex flex-col items-start gap-4">
          <div className="flex items-center gap-4">
            <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-gold-400/40 bg-ink-800 font-mono text-sm text-gold-300 glow-gold-sm">
              0{i + 1}
            </span>
            <span className="lg:hidden h-px flex-1 bg-gold-400/20" />
          </div>
          <h3 className="font-display text-lg font-bold text-ink-50">{step.title}</h3>
          <p className="text-sm text-zinc-400 leading-relaxed">{step.desc}</p>
        </Reveal>
      ))}
    </div>
  );
}